/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Empty_Filter_TitleInputs */



/**
* | output |
* | --- |
* | "No period matches these filters" |
*
* @param {Partner_Detail_Empty_Filter_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_empty_filter_title = /** @type {((inputs?: Partner_Detail_Empty_Filter_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Empty_Filter_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Zeitraum entspricht diesen Filtern")
	return /** @type {LocalizedString} */ ("No period matches these filters")
});